import IconButton, { Props as IconButtonProps } from 'components/@extended/IconButton';
import { Tooltip } from 'components/ui/tooltip';
import { ReactElement, ReactNode } from 'react';
import { cn } from 'utils/cn';

export function CallForActionButtonTooltip({ title, children }: { title: ReactNode; children: ReactElement }) {
    if (!title) return children;
    return <Tooltip content={title}>{children}</Tooltip>;
}

export function CallForActionButton({ className, ...props }: IconButtonProps) {
    return (
        <IconButton
            {...props}
            className={cn(
                "bg-info-darker/10 text-info-darker hover:bg-info-darker hover:text-primary-foreground size-8 [&_svg:not([class*='size-'])]:size-5",
                className
            )}
        />
    );
}

/** A row's own button (kebab, expand chevron). The new design draws it on the row's surface, stripe or hover. */
export function TableRowCallForActionButton({ className, ...props }: IconButtonProps) {
    return (
        <CallForActionButton
            {...props}
            className={cn(
                'bg-grey-0 text-grey-500 hover:bg-grey-200 hover:text-grey-900 new:bg-transparent new:hover:bg-neutral-tint',
                className
            )}
        />
    );
}
